<template>
    <div class="wl-matter-log-container">
        <div style="height: 100%" v-if="!addOrEditVisible">
            <div class="wl-container">
                <NewComments :messageType="messageType" :siteId="siteId"></NewComments>
                <div class="wl-content-container content-with-comments">
                    <div class="search-line1">
                        <ul class="tab-cls">
                            <li v-if="getSite.hasInterim" :class="active === '1' ? 'active' : ''" @click="handleClick('1')">
                                {{ $t('COMMON_INTERIM') }}
                            </li>
                            <li :class="active === '2' ? 'active' : ''" @click="handleClick('2')">{{ $t('COMMON_FINAL') }}</li>
                        </ul>
                        <div :class="['clean-filter', cleanFilterActive ? 'clean-filter-active' : '']" @click="clearFilter">
                            <img src="@/assets/img/icon-screen.svg" class="table-setting-icon" />
                            {{ $t('clear_filter') }}
                        </div>
                    </div>
                    <div class="search-line2">
                        <div class="search-line2-left">
                            <span v-for="item in statusDict" :key="item.key">
                                <img :src="getIconSvg(item.icon)" width="100%" class="status-icon" />
                                {{ $t(item.label) }}
                            </span>
                        </div>
                        <div class="search-line2-right">
                            <!-- <el-button class="cancel-btn" @click="clearFilter">{{ $t('clear_filter') }}</el-button> -->
                            <el-button v-if="getUser.userType == '1'" class="wl-green" @click="onAddShow" icon="el-icon-plus"
                                >{{ $t('MATTER_ADD_ITEM') }}
                            </el-button>
                            <!-- 批量删除 -->
                            <el-button
                                v-if="getUser.userType == '1'"
                                class="wl-green svg-btn"
                                @click="onBatchDeleteClick"
                                :disabled="batch.show"
                                ><img src="@/assets/img/icon-batchdeletion.svg" width="100%" class="btn-icon" />{{
                                    $t('patch_delete')
                                }}</el-button
                            >
                            <el-button class="wl-green svg-btn" :disabled="!hasPermission('download')" @click="exportMatterLog"
                                ><img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />{{
                                    $t('COMMON_EXPORT')
                                }}</el-button
                            >
                        </div>
                    </div>

                    <!-- 表格 -->
                    <div :class="['table-container-wrapper', getTableHeight]">
                        <el-table
                            height="100%"
                            :data="data"
                            border
                            v-loading="tableLoading"
                            stripe
                            @selection-change="
                                (e) => {
                                    batch.selectRows = e
                                }
                            "
                            ref="multipleTable"
                        >
                            <!-- 多选 -->
                            <el-table-column v-if="batch.show" type="selection" width="55"></el-table-column>
                            <!-- 实体 -->
                            <el-table-column
                                prop="entityList"
                                align="center"
                                :label="$t('TABLE_HEADER_entityList')"
                                show-overflow-tooltip
                                width="200px"
                            >
                                <template slot-scope="scope">
                                    <span v-for="(item, index) in scope.row.entityList" :key="index">
                                        <span v-if="index == scope.row.entityList.length - 1">{{ item.entityName }}</span>
                                        <span v-else>{{ item.entityName }}/</span>
                                    </span>
                                </template>
                            </el-table-column>
                            <!-- 事项 -->
                            <el-table-column
                                prop="title"
                                align="center"
                                width="200px"
                                show-overflow-tooltip
                                :label="$t('TABLE_HEADER_matter')"
                            >
                                <template slot="header">
                                    <div class="header-with-popup">
                                        {{ $t('TABLE_HEADER_matter') }}
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="search.data.title"
                                            labelKey="v"
                                            valueKey="v"
                                            :inputFilterKey="['v']"
                                            :options="titleOptions.map((v, k) => ({ v, k }))"
                                        ></MultiSelectPopver>
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- 事项 问题类型 -->
                            <el-table-column align="center" :label="$t('TABLE_HEADER_Deficiency')" width="150px">
                                <template slot="header">
                                    <div class="header-with-popup">
                                        {{ $t('FORM_LABEL_matterType') }}
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="search.data.matterType"
                                            labelKey="label"
                                            valueKey="value"
                                            :inputFilterKey="['value', 'label']"
                                            :options="matterLogTypeDescs"
                                        ></MultiSelectPopver>
                                    </div>
                                </template>

                                <template slot-scope="scope">
                                    <span>{{ mapMatterData[scope.row.typeDesc] }}</span>
                                </template>
                            </el-table-column>
                            <!-- 事项 问题描述 -->
                            <el-table-column align="center" prop="matterDesc" width="300px" show-overflow-tooltip>
                                <template slot="header">
                                    <div class="header-with-popup">
                                        <span v-html="$t('TABLE_HEADER_Description')"></span>
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="search.data.matterDesc"
                                            labelKey="v"
                                            valueKey="v"
                                            :inputFilterKey="['v']"
                                            :options="matterDescOptions.map((v, k) => ({ v, k }))"
                                        ></MultiSelectPopver>
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- 财务报表科目 -->
                            <el-table-column prop="category" align="center" width="150px" :label="$t('TABLE_HEADER_category')">
                                <template slot="header">
                                    <div class="header-with-popup">
                                        <div v-html="$t('TABLE_HEADER_category')"></div>
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="search.data.category"
                                            labelKey="label"
                                            valueKey="value"
                                            :inputFilterKey="['value', 'label']"
                                            :options="matterlogCategorys"
                                        ></MultiSelectPopver>
                                    </div>
                                </template>
                            </el-table-column>

                            <!-- 下面开始这四列，表头都是有一个图表可以修改一列，表格里都是有下拉可以单独修改的 -->
                            <!-- 优先级 -->
                            <el-table-column align="center" :label="$t('FORM_LABEL_priority')" width="130px">
                                <template slot="header" slot-scope="scope">
                                    <div class="header-with-popup">
                                        <el-dropdown style="margin-right: 5px" v-if="getUser.userType == 1" @command="batchChangePriority">
                                            <span class="el-dropdown-link">
                                                <i
                                                    class="el-icon-edit-outline table-header-edit-cls"
                                                    :title="$t('FORM_LABEL_clientOwner')"
                                                ></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item
                                                    v-for="v in priority"
                                                    :key="v.value"
                                                    :command="v.value"
                                                    :value="v.value"
                                                    style="font-size: 12px"
                                                    >{{ v.label }}</el-dropdown-item
                                                >
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                        {{ $t('FORM_LABEL_priority') }}
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="search.data.matterPriority"
                                            labelKey="label"
                                            valueKey="value"
                                            :inputFilterKey="['value', 'label']"
                                            :options="allPriority"
                                        ></MultiSelectPopver>
                                    </div>
                                </template>
                                <template slot-scope="scope">
                                    <el-select
                                        v-model="scope.row.matterPriority"
                                        @change="updateMatterLogSingleCell(scope.row, 'matterPriority')"
                                        v-if="getUser.userType == 1"
                                    >
                                        <el-option v-for="(v, k) in priority" :key="k" :value="v.value" :label="v.label"> </el-option>
                                    </el-select>
                                    <span v-else>
                                        {{
                                            priority.map((v) => v.value).includes(scope.row.matterPriority)
                                                ? $t(priority.find((v) => v.value == scope.row.matterPriority).label)
                                                : ''
                                        }}
                                    </span>
                                </template>
                            </el-table-column>
                            <!-- 审计事项 问题状态 -->
                            <el-table-column prop="typeDesc" align="center" :label="$t('TABLE_HEADER_Issues')" width="170px">
                                <template slot="header" slot-scope="scope">
                                    <div class="header-with-popup">
                                        <el-dropdown style="margin-right: 5px" v-if="getUser.userType == 1" @command="batchChangeTypeDesc">
                                            <span class="el-dropdown-link">
                                                <i
                                                    class="el-icon-edit-outline table-header-edit-cls"
                                                    :title="$t('TABLE_HEADER_Issues')"
                                                ></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item
                                                    v-for="v in statusDict"
                                                    :key="v.value"
                                                    :command="v.value"
                                                    :value="v.value"
                                                    style="font-size: 12px"
                                                    >{{ $t(v.label) }}</el-dropdown-item
                                                >
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                        {{ $t('TABLE_HEADER_Issues') }}
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="chooseStatus"
                                            labelKey="xlabel"
                                            valueKey="value"
                                            :inputFilterKey="['value', 'xlabel']"
                                            :options="statusDict.map((v) => ({ xlabel: $t(v.label), ...v }))"
                                        ></MultiSelectPopver>
                                    </div>
                                </template>
                                <template slot-scope="scope">
                                    <el-dropdown v-if="getUser.userType == 1" @command="(value) => updateMatterLogSingleCellBtDropdown(value, scope.row.attachmentList)">
                                        <span class="el-dropdown-link">
                                            <img :src="getIconSvg(showStatus(scope.row))" width="100%" class="status-icon" />
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                v-for="(v, k) in statusDict"
                                                :key="k"
                                                :value="v.value"
                                                :command="`${v.value}|matterStatus|${scope.row.id}`"
                                            >
                                                <img
                                                    :src="getIconSvg(showStatus({ matterStatus: v.value }))"
                                                    width="100%"
                                                    class="status-icon"
                                                />
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <img v-else :src="getIconSvg(showStatus(scope.row))" width="100%" class="status-icon" />
                                </template>
                            </el-table-column>
                            <!-- 毕马威负责人 -->
                            <el-table-column prop="kpmgUserName" align="center" width="150px">
                                <template slot="header" slot-scope="scope">
                                    <div class="header-with-popup">
                                        <el-dropdown
                                            style="margin-right: 5px"
                                            v-if="getUser.userType == 1"
                                            @command="batchChangeKpmgUserName"
                                        >
                                            <span class="el-dropdown-link">
                                                <i
                                                    class="el-icon-edit-outline table-header-edit-cls"
                                                    :title="$t('FORM_LABEL_kpmgOwner')"
                                                ></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-input
                                                    v-model="kpmgOwnerDropdownFilterInput"
                                                    size="mini"
                                                    :placeholder="$t('FORM_LABEL_kpmgOwner')"
                                                    clearable
                                                ></el-input>
                                                <el-dropdown-item
                                                    v-for="v in kpmgOwnerListDropdown"
                                                    :key="v.id"
                                                    :command="v.id"
                                                    :value="v.id"
                                                    style="font-size: 12px"
                                                    >{{ `${v.userName}（${v.profitCenter}）` }}</el-dropdown-item
                                                >
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                        {{ $t('FORM_LABEL_kpmgOwner') }}
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="search.data.kpmgOwner"
                                            labelKey="xlabel"
                                            valueKey="id"
                                            :inputFilterKey="['id', 'xlabel']"
                                            :options="kpmgOwnerList.map((v) => ({ xlabel: `${v.userName} ( ${v.profitCenter} ) `, ...v }))"
                                        ></MultiSelectPopver>
                                    </div>
                                </template>
                                <template slot-scope="scope">
                                    <el-select
                                        v-model="scope.row.kpmgOwner"
                                        @change="updateMatterLogSingleCell(scope.row, 'kpmgUser')"
                                        v-if="getUser.userType == 1"
                                    >
                                        <el-option
                                            v-for="(v, k) in kpmgOwnerList"
                                            :key="k"
                                            :value="v.id"
                                            :label="`${v.userName}（${v.profitCenter}）`"
                                        >
                                        </el-option>
                                    </el-select>
                                    <span v-else>
                                        {{ scope.row.kpmgUserName ? scope.row.kpmgUserName : '-' }}
                                    </span>
                                </template>
                            </el-table-column>
                            <!-- 客户负责人 -->
                            <el-table-column align="center" width="150px">
                                <template slot="header" slot-scope="scope">
                                    <div class="header-with-popup">
                                        <el-dropdown
                                            style="margin-right: 5px"
                                            v-if="getUser.userType == 1"
                                            @command="batchChangeClientUserName"
                                        >
                                            <span class="el-dropdown-link">
                                                <i
                                                    class="el-icon-edit-outline table-header-edit-cls"
                                                    :title="$t('FORM_LABEL_clientOwner')"
                                                ></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-input
                                                    v-model="clientOwnerDropdownFilterInput"
                                                    size="mini"
                                                    :placeholder="$t('FORM_LABEL_clientOwner')"
                                                    clearable
                                                ></el-input>
                                                <el-dropdown-item
                                                    v-for="(v, k) in clientOwnerListDropdown"
                                                    :key="k"
                                                    :command="v.userId"
                                                    :value="v.userId"
                                                    style="font-size: 12px"
                                                    >{{ v.label }}</el-dropdown-item
                                                >
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                        {{ $t('FORM_LABEL_clientOwner') }}
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="search.data.clientOwner"
                                            labelKey="label"
                                            valueKey="userId"
                                            :inputFilterKey="['userId', 'label']"
                                            :options="clientUserSelectDataFix"
                                        ></MultiSelectPopver>
                                    </div>
                                </template>
                                <template slot-scope="scope">
                                    <el-select
                                        v-model="scope.row.clientOwner"
                                        @change="updateMatterLogSingleCell(scope.row, 'clientUser')"
                                        v-if="getUser.userType == 1"
                                    >
                                        <el-option v-for="(v, k) in clientUserSelectDataFix" :key="k" :value="v.userId" :label="v.label">
                                        </el-option>
                                    </el-select>
                                    <div
                                        v-else
                                        v-html="
                                            clientOwnerList.map((v) => v.userId).includes(scope.row.clientOwner)
                                                ? (() => {
                                                      const _c = clientOwnerList.find((v) => v.userId == scope.row.clientOwner)
                                                      return !!_c ? `<div>${_c.userName}</div><div>(${_c.email})</div>` : '-'
                                                  })()
                                                : '-'
                                        "
                                    ></div>
                                </template>
                            </el-table-column>
                            <!-- 创建于 -->
                            <el-table-column align="center" :label="$t('Created_Date')" width="120px">
                                <template slot="header">
                                    <div class="header-with-popup">
                                        {{ $t('create_date') }}
                                        <DatePickerPopover
                                            :value.sync="search.data.createDate"
                                            :hidePopperSearch="hidePopperSearch"
                                        ></DatePickerPopover>
                                    </div>
                                </template>
                                <template slot-scope="scope">
                                    {{ scope.row.createDateStamp | formatDate }}
                                </template>
                            </el-table-column>
                            <!-- 创建人 -->
                            <el-table-column prop="createBy" align="center" :label="$t('SITE_TABLE_HEADER_CREATE_BY')" width="150px">
                                <template slot="header">
                                    <div class="header-with-popup">
                                        {{ $t('SITE_TABLE_HEADER_CREATE_BY') }}
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="search.data.createBy"
                                            labelKey="xlabel"
                                            valueKey="id"
                                            :inputFilterKey="['xlabel', 'id']"
                                            :options="
                                                kpmgOwnerList
                                                    .filter((v) => v.id != 'Blank')
                                                    .map((v) => ({
                                                        xlabel: `${v.userName}（${v.profitCenter}）`,
                                                        id: v.userAccount
                                                    }))
                                            "
                                        ></MultiSelectPopver>
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- 修改时间 -->
                            <el-table-column align="center" width="130px">
                                <template #header>
                                    <div class="header-with-popup">
                                        {{ $t('SITE_TABLE_HEADER_MODIFIED_TIME') }}
                                        <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                            <template #reference>
                                                <div class="th-filter-down">
                                                    <i
                                                        :class="[
                                                            'el-icon-arrow-down',
                                                            dateRange.length > 0 ? 'el-icon-arrow-down-active' : ''
                                                        ]"
                                                    ></i>
                                                </div>
                                            </template>
                                            <template>
                                                <el-date-picker
                                                    v-model="dateRange"
                                                    class="search-item input-with-select"
                                                    type="daterange"
                                                    range-separator="~"
                                                    value-format="yyyy-MM-dd"
                                                    :start-placeholder="$t('SITE_TABLE_HEADER_MODIFIED_TIME')"
                                                    :end-placeholder="$t('SITE_TABLE_HEADER_MODIFIED_TIME')"
                                                    clearable
                                                >
                                                </el-date-picker>
                                            </template>
                                        </el-popover>
                                    </div>
                                </template>
                                <template slot-scope="scope">
                                    {{ scope.row.updateDateStamp | formatDate }}
                                </template>
                            </el-table-column>
                            <!-- 操作人 -->
                            <el-table-column prop="updateBy" align="center" :label="$t('SITE_TABLE_HEADER_MODIFIED_BY')" width="150px">
                                <template slot="header">
                                    <div class="header-with-popup">
                                        {{ $t('SITE_TABLE_HEADER_MODIFIED_BY') }}
                                        <MultiSelectPopver
                                            :hidePopperSearch="hidePopperSearch"
                                            :value.sync="search.data.updateBy"
                                            labelKey="xlabel"
                                            valueKey="id"
                                            :inputFilterKey="['xlabel', 'id']"
                                            :options="
                                                kpmgOwnerList
                                                    .filter((v) => v.id != 'Blank')
                                                    .map((v) => ({
                                                        xlabel: `${v.userName}（${v.profitCenter}）`,
                                                        id: v.userAccount
                                                    }))
                                            "
                                        ></MultiSelectPopver>
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- 固定列 -->
                            <!-- 文件列表 -->
                            <el-table-column align="center" width="120" fixed="right">
                                <template #header>
                                    <div class="header-with-popup">
                                        {{ $t('TABLE_HEADER_fileNameList') }}
                                        <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                            <template #reference>
                                                <div class="th-filter-down">
                                                    <i
                                                        :class="[
                                                            'el-icon-arrow-down',
                                                            search.data.searchContent ? 'el-icon-arrow-down-active' : ''
                                                        ]"
                                                    ></i>
                                                </div>
                                            </template>
                                            <template>
                                                <el-input
                                                    class="search-item input-with-select"
                                                    v-model="search.data.searchContent"
                                                    size="medium"
                                                    :placeholder="$t('fileNameKeyword')"
                                                    clearable
                                                ></el-input>
                                            </template>
                                        </el-popover>
                                    </div>
                                </template>
                                <template slot-scope="scope">
                                    <span
                                        class="table-filelength"
                                        v-show="scope.row.attachmentList && scope.row.attachmentList.length > 0"
                                        @click="onFileLengthClick(scope.row)"
                                    >
                                        {{ scope.row.attachmentList.length }}
                                    </span>
                                </template>
                            </el-table-column>
                            <!-- 上传 -->
                            <el-table-column align="center" :label="$t('COMMON_UPLOAD')" width="70" fixed="right">
                                <template slot-scope="scope">
                                    <i
                                        :class="[hasPermission('upload') ? 'wl-icon-upload' : 'wl-icon-not-upload', 'el-icon-upload']"
                                        @click="onUploadClick(scope.row)"
                                    />
                                </template>
                            </el-table-column>
                            <!-- 留言 -->
                            <el-table-column align="center" :label="$t('TABLE_HEAD_COMMENTS')" width="100" fixed="right">
                                <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEAD_COMMENTS') }}
                                    <DatePickerPopover
                                        :value.sync="search.data.commentDate"
                                        :hidePopperSearch="hidePopperSearch"
                                    ></DatePickerPopover>
                                </div>
                            </template>
                                <template slot-scope="scope">
                                    <div class="flex  item-center justify-center">
                                        <i
                                        :class="[
                                            scope.row.todayCommentCount > 0 ? 'wl-icon-messageBoard' : 'wl-icon-messageBoardNull',
                                            'el-icon-s-comment'
                                            ]"
                                            @click="onCommentClick(scope.row)"
                                        ></i>
                                        <span v-if="scope.row.todayCommentCount"> 
                                            <span class="message-today">{{ scope.row.todayCommentCount }}</span>/ 
                                        </span>
                                        <span v-if="scope.row.commentList.length > 0"> 
                                            {{ scope.row.commentList.length }}
                                        </span>
                                    </div> 
                                </template>
                            </el-table-column>
                            <!-- 操作 -->
                            <el-table-column
                                v-if="getUser.userType == '1'"
                                align="center"
                                :label="$t('TABLE_HEADER_Action')"
                                width="90"
                                fixed="right"
                            >
                                <template slot-scope="scope">
                                    <i class="el-icon-edit-outline wl-icon-edit" @click="onEditShow(scope.row)"></i>
                                    <i style="margin-left: 10px" class="el-icon-delete wl-icon-delete" @click="onDelete(scope.row)"></i>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!-- 批量操作 -->
                    <div class="batch-operation" v-if="batch.show">
                        <el-button class="cancel-btn" @click="onBatchCancel" :loading="batch.loading">{{ $t('btn_cancel') }}</el-button>
                        <el-button
                            class="wl-green"
                            @click="commitBatchDelete"
                            v-if="batch.mode == 'delete'"
                            :disabled="batch.selectRows.length == 0"
                            :loading="batch.loading"
                            >{{ $t('patch_delete') }}</el-button
                        >
                    </div>
                    <!-- 分页 -->
                    <el-pagination
                        class="wl-pagination"
                        :current-page="pagination.pageNum"
                        :page-size="pagination.pageSize"
                        @current-change="onCurrentPageChange"
                        @size-change="onSizeChange"
                        :page-sizes="[10, 50, 100]"
                        layout="prev, pager, next, sizes, total"
                        :total="pagination.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <add-or-edit v-else :onRefresh="getMatterLog" :onCancel="onAddOrEditShow" :onAddOrEdit="onAddOrEdit" :data="current" />
        <entity :onAdd="getMatterLog" :entityData="entityData" />
        <!-- 留言弹窗 -->
        <el-dialog
            :title="$t('TABLE_HEADER_Message')"
            top="10vh"
            :visible="comment.show"
            width="45%"
            :close-on-click-modal="false"
            append-to-body
            @close="onCommentDialogClose"
        >
            <div class="messageViewer">
                <template :loading="comment.loading">
                    <el-row class="itemWarp" v-for="(v, k) in comment.data" :key="k">
                        <el-col :span="18" :class="v.userType == getUser.userType ? 'floatRight' : 'floatLeft'">
                            <el-avatar
                                :class="v.userType == getUser.userType ? 'floatRight' : 'floatLeft'"
                                size="small"
                                :src="comment.circleUrl"
                            ></el-avatar>
                            <div class="messageWarp" :class="v.userType == getUser.userType ? 'floatRight' : 'floatLeft'">
                                <div class="messageBy">
                                    {{ v.commentUser }}【<span>{{ v.commentTime | formatDateTime }}</span
                                    >】
                                </div>
                                <div class="messageContent" :class="v.userType == getUser.userAccount ? 'rightMessage' : 'leftMessage'">
                                    {{ v.comment }}
                                    <el-popconfirm
                                        v-if="v.createBy === getUser.userAccount"
                                        :title="$t('msg_delete_sure')"
                                        @confirm="deleteMessage(v)"
                                    >
                                        <i slot="reference" class="el-icon-delete deleteButton leftButton"></i>
                                    </el-popconfirm>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </template>
            </div>
            <div class="addMessage">
                <el-input
                    type="textarea"
                    resize="none"
                    maxlength="300"
                    show-word-limit
                    :rows="3"
                    :placeholder="$t('ENTER_MESSAGE_CONTENT')"
                    v-model="comment.content"
                    @keyup.enter.exact.native="commentCommit"
                    :disabled="comment.loading"
                >
                </el-input>
                <i
                    :title="$t('comment_send')"
                    :class="['el-icon-s-promotion', 'wl-icon-send', comment.loading ? 'wl-icon-send-disabled' : '']"
                    @click="commentCommit"
                ></i>
            </div>
        </el-dialog>

        <!-- 上传弹窗 -->
        <Upload
            v-if="uploadVisible"
            ref="upload"
            :afterDelete="getMatterLog"
            :matterLogId="matterLogId"
            :afterUploadAllFinish="afterUploadAllFinish"
            :initData="initData"
        />
        <!-- 附件弹窗 -->
        <el-dialog
            :visible="fileTable.show"
            :title="$t('FORM_LABEL_attachmentList')"
            top="10vh"
            width="70%"
            :close-on-click-modal="false"
            append-to-body
            :before-close="
                () => {
                    fileTable.show = false
                    fileTable.limit = 10
                    fileTable.page = 1
                }
            "
        >
            <el-table :data="fileTablePageData" max-height="500" border :row-class-name="tableRowClassName">
                <el-table-column show-overflow-tooltip min-width="150" :label="$t('DOWNLOAD_FILE_NAME')">
                    <template slot-scope="scope">
                        <div
                            :class="[
                                'file-table-name',
                                canDownload(scope.row) && hasPermission('download') ? 'file-table-name-canDownload' : ''
                            ]"
                            @click="handleFileClick(scope.row, true)"
                        >
                            <i v-if="canDownload(scope.row) && hasPermission('download')" class="el-icon-download" />
                            {{ scope.row.name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('DOWNLOAD_SIZE')">
                    <template slot-scope="scope">
                        <span>{{ scope.row.size | fileSize }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="downloadDate" show-overflow-tooltip :label="$t('DOWNLOAD_TIME')"> </el-table-column>
                <el-table-column prop="downloadBy" show-overflow-tooltip :label="$t('DOWNLOAD_BY')"> </el-table-column>
                <el-table-column :label="$t('UPLOAD_BY')" prop="uploadBy" show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('UPLOAD_TIME')" prop="uploadDate" show-overflow-tooltip></el-table-column>
                <el-table-column prop="action" width="70" show-overflow-tooltip align="center" :label="$t('COMMON_DELETE')">
                    <template slot-scope="scope">
                        <!-- 已接受条目不可删除 || 毕马威不可删除客户上传的文件 || 客户也不可删除毕马威上传的文件 -->
                        <i class="el-icon-delete delete" v-if="!noAuthority(scope.row)" @click="onDeleteClick(scope.row)" />
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                small
                class="wl-pagination"
                :total="fileTable.data.length"
                :page-size="fileTable.limit"
                :page-sizes="[10, 50, 100]"
                layout="prev, pager, next, sizes, total"
                @current-change="(e) => (fileTable.page = e)"
                @size-change="
                    (e) => {
                        fileTable.limit = e
                        fileTable.page = 1
                    }
                "
            >
            </el-pagination>
        </el-dialog>
    </div>
</template>
<script>
import API from '@/api'
import SelectMulti from '@/components/common/SelectMulti'
import PopHover from './pop-up'
import addOrEdit from './add-update-pop'
import { deleteConfirm, isIE, loading, dateFormat } from '@/utils'
import { mapGetters } from 'vuex'
import Entity from '@/components/common/entity'
import { userEntity } from '@/mixins/getUserEntity.js'
import Upload from './upload'
import { userPermission } from '@/mixins/userPermission.js'
import MultiSelectPopver from '@/components/common/MultiSelectPopver.vue'
import DatePickerPopover from '@/components/common/DatePickerPopover.vue'
import * as _ from 'lodash'
import { downloadSingleFile,downloadFileByUrl } from '@/utils/useDownload'
import { treeToList } from '@/utils/formatTree'
import NewComments from '@/components/common/NewComments.vue'

export default {
    data() {
        return {
            active: '2',
            tableLoading: false,
            data: [],
            dateRange: [],
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            chooseStatus: [],
            statusDict: [
                {
                    value: 2,
                    label: 'dictionary_matterLog_status_open',
                    icon: 'icon-not-started'
                },
                {
                    value: 1,
                    label: 'dictionary_matterLog_status_being',
                    icon: 'icon-in-progress'
                },

                {
                    value: 3,
                    label: 'dictionary_matterLog_status_close',
                    icon: 'icon-completed'
                }
            ],
            priority: [],
            allPriority:[],
            addOrEditVisible: false,
            current: {},
            // siteId: '',
            mapMatterData: {},
            matterlogCategorys: [],
            showSearchParams: false,
            comment: {
                show: false,
                data: [],
                loading: false,
                circleUrl: require('@/assets/img/messageboard1.png'),
                content: '',
                row: {}
            },
            kpmgOwnerList: [],
            kpmgOwnerDropdownFilterInput: '',
            clientOwnerList: [],
            clientOwnerDropdownFilterInput: '',
            search: {
                data: {
                    title: [],
                    category: [],
                    matterType: [],
                    kpmgOwner: [],
                    clientOwner: [],
                    status: '',
                    matterPriority: [],
                    matterDesc: [],
                    searchContent: '',
                    createDate: ['', ''],
                    createBy: [],
                    updateBy: [],
                    commentDate: []
                }
            },
            fileTable: {
                show: false,
                data: [],
                matterId: 0,
                page: 1,
                limit: 10
            },
            batch: {
                show: false,
                selectRows: [],
                mode: '', // delete
                loading: false
            },
            matterLogIdList: [],
            matterInfo: [],
            notify: null,
            downloadAble: false,
            matterLogId: '',
            matterLogTypeDescs: [],
            initData: {},
            uploadVisible: false
        }
    },
    mixins: [userEntity, userPermission],
    computed: {
        clientOwnerListDropdown() {
            return this.clientUserSelectDataFix.filter((v) => {
                return (
                    (v.userName && v.userName.toLowerCase().indexOf(this.clientOwnerDropdownFilterInput.toLowerCase()) > -1) ||
                    (v.email && v.email.toLowerCase().indexOf(this.clientOwnerDropdownFilterInput.toLowerCase()) > -1)
                )
            })
        },
        kpmgOwnerListDropdown() {
            return this.kpmgOwnerList.filter((v) => {
                return (
                    (v.userName && v.userName.toLowerCase().indexOf(this.kpmgOwnerDropdownFilterInput.toLowerCase()) > -1) ||
                    (v.email && v.email.toLowerCase().indexOf(this.kpmgOwnerDropdownFilterInput.toLowerCase()) > -1)
                )
            })
        },
        ...mapGetters('common', {
            getUser: 'getUser',
            getEntityIds: 'getEntityIds',
            getSite: 'getSite'
        }),
        entityDataTotalSize(){
            const flatTree = treeToList(this.entityData).filter(item=>!item.disabled)
            return flatTree.length
        },
        getTableHeight() {
            let className = ''
            if (this.showSearchParams && this.batch.show) {
                className = 'show-search-operator'
            } else if (this.showSearchParams && !this.batch.show) {
                className = 'show-search-row'
            } else if (!this.showSearchParams && this.batch.show) {
                className = 'show-table-bottom-operate'
            }
            return className
        },
        titleOptions() {
            return [...new Set(this.matterInfo.map((v) => v.title))]
        },
        matterDescOptions() {
            // return [
            //     ...(new Set(this.matterInfo.map(v => v.matterDesc)))
            // ]
            return this.matterInfo.map((item) => {
                if (item.matterDesc === '') {
                    item.matterDesc = this.$t('common_empty')
                }
                return item.matterDesc
            })
        },
        fileTablePageData() {
            return this.fileTable.data.filter((v, k) => {
                return (
                    k >= (this.fileTable.page - 1) * this.fileTable.limit &&
                    k < (this.fileTable.page - 1) * this.fileTable.limit + this.fileTable.limit
                )
            })
        },
        clientUserSelectDataFix() {
            const needFixData = this.data.filter((v) => !this.clientOwnerList.map((vv) => vv.id).includes(v.clientOwner))
             
            return [
                ...this.clientOwnerList,
                ...needFixData.map((v) => {
                    return { userId: v.clientOwner, userName: '', email: '' }
                })
            ].map((v) => {
                let _label = []

                if (v.userName) {
                    if (v.userName === 'Blank') {
                        v.userName = this.$t('common_empty')
                    }
                    _label.push(v.userName)
                }
                /*if (v.email) {
                    _label.push(`（${v.email}）`)
                }*/
                return {
                    ...v,
                    label: _label.length > 0 ? _label.join('') : ' '
                }
            })
        },
        cleanFilterActive() {
            return (
                (this.search.data.title && this.search.data.title.length > 0) ||
                (this.search.data.category && this.search.data.category.length > 0) ||
                (this.search.data.matterType && this.search.data.matterType.length > 0) ||
                (this.search.data.kpmgOwner && this.search.data.kpmgOwner.length > 0) ||
                (this.search.data.clientOwner && this.search.data.clientOwner.length > 0) ||
                !!this.search.data.status ||
                (this.search.data.matterPriority && this.search.data.matterPriority.length > 0) ||
                (this.search.data.matterDesc && this.search.data.matterDesc.length > 0) ||
                !!this.search.data.searchContent ||
                (this.search.data.createDate &&
                    this.search.data.createDate.length == 2 &&
                    this.search.data.createDate.every((v) => v !== '')) ||
                (this.search.data.createBy && this.search.data.createBy.length > 0) ||
                (this.search.data.updateBy && this.search.data.updateBy.length > 0)||
                (this.getEntityIds.length!==this.entityDataTotalSize)||
                this.chooseStatus.length>0||
                (this.search.data.commentDate && !!this.search.data.commentDate[0])
            )
        },
        messageType(){
            return this.active === '1'?'8':'9'
        },
        siteId(){
            return this.getSite.siteId
        }
        
    },
    methods: {
        noAuthority(file) {
            return (
                (file.uploadBy && file.uploadBy.indexOf('(') === -1 && this.getUser.userType === '1') ||
                (file.uploadBy && file.uploadBy.indexOf('(') !== -1 && this.getUser.userType === '2')
            )
        },
        hidePopperSearch() {
            this.getMatterLog()
        },
        getIconSvg(icon) {
            return icon ? require(`@/assets/img/${icon}.svg`) : ''
        },
        // 毕马威上传的用蓝底表示
        tableRowClassName({ row, rowIndex }) {
            if (row.uploadBy && row.uploadBy.indexOf('(') != -1 && row.uploadBy.indexOf(')') != -1) {
                return 'kp-update-row'
            }
            return ''
        },
        // 查询当前站点downloadable
        async queryLimits() {
            const { code, data } = await API.clientUser.getSiteConfig({ param: this.getSite.siteId })
            if (code == '1') {
                this.downloadAble = !!data.downloadable
            } else {
                this.$message.error(this.$t(code))
            }
            // 当前文件uploadby
            let userType = this.getUser.userType
            if (userType == '1') {
                this.curUserName = this.getUser.userName
            } else {
                this.curUserName = this.getUser.userAccount
            }
        },
        // 客户端之间是否允许互相下载取决于站点管理中的配置
        canDownload(file) {
            if (this.getUser.userType == '2') {
                if (this.downloadAble) return true
                if (!file.uploadBy) return true
                const nameIsKp = file.uploadBy.indexOf('(') != -1 && file.uploadBy.indexOf(')') != -1
                if (!nameIsKp && file.uploadBy != this.getUser.userName) {
                    return false
                }
            }
            return true
        },
        clearFilter() {
            this.$store.commit('common/setEntityIds', this.allEntityIds)
            this.search.data = {
                ...{
                    title: [],
                    category: [],
                    matterType: [],
                    kpmgOwner: [],
                    clientOwner: [],
                    status: '',
                    matterPriority: [],
                    matterDesc: [],
                    searchContent: '',
                    createDate: ['', ''],
                    createBy: [],
                    updateBy: [],
                    commentDate: []
                }
            }
            this.pagination = {
                ...{
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                }
            }
            this.auditType = '2'
            this.chooseStatus = []
            this.dateRange = []
            this.getMatterLog()
        },
        /**
         * 这个函数和下一个函数都是处理单元格内下拉编辑单个值的
         * 只有带图形的下拉是用这个单独处理的
         */
        updateMatterLogSingleCellBtDropdown(value, attachmentList) {
            const params = value.split('|')
            this.updateMatterLogSingleCell(
                {
                    id: params[2],
                    [params[1]]: params[0],
                    attachmentList,
                },
                params[1]
            )
            this.data.find((v) => v.id == params[2])[params[1]] = params[0]
        },
        updateMatterLogSingleCell(row, key = '') {
            let value = row[key]
            if (key == 'kpmgUser') {
                value = { id: row.kpmgOwner }
            } else if (key == 'clientUser') {
                value = { id: row.clientOwner }
            }
            const params = {
                id: row.id,
                [key]: value,
                siteId: this.siteId,
                attachmentList: row.attachmentList ? row.attachmentList : []
            }
            API.matterLogs.kpUpdateMatterLog(params).then((res) => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.getMatterLog()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        onDeleteClick(row) {
            deleteConfirm().then(() => {
                const params = {
                    mattterFileId: row.id,
                    siteId: this.siteId
                }
                API.matterLogs.deleteMatterSingleFile(params).then((res) => {
                    if (res.code === '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.fileTable.data.splice(
                            this.fileTable.data.findIndex((v) => v.id == row.id),
                            1
                        )
                        this.getMatterLog()
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            })
        },
        onFileLengthClick(row) {
            this.fileTable.data = [...row.attachmentList]
            this.fileTable.matterId = row.id
            this.fileTable.show = true
        },
        onMatterDescChange(e) {
            if (e.includes(`[${this.$t('select_all')}]`)) {
                this.search.data.matterDesc = this.matterDescOptions.filter(
                    (v) => ![`[${this.$t('select_all')}]`, `[${this.$t('unselect_all')}]`].includes(v)
                )
            } else if (e.includes(`[${this.$t('unselect_all')}]`)) {
                this.search.data.matterDesc = []
            }
        },
        onTitleChange(e) {
            if (e.includes(`[${this.$t('select_all')}]`)) {
                this.search.data.title = this.titleOptions.filter(
                    (v) => ![`[${this.$t('select_all')}]`, `[${this.$t('unselect_all')}]`].includes(v)
                )
            } else if (e.includes(`[${this.$t('unselect_all')}]`)) {
                this.search.data.title = []
            }
        },
        async queryMatterInfo() {
            const res = await API.matterLogs.queryMatterInfo({
                auditType: this.active,
                siteId: this.siteId
            })
            this.matterInfo = res.data.records != null && res.data.records.length > 0 ? res.data.records : []
        },
        onBatchCancel() {
            this.$refs.multipleTable.clearSelection()
            this.batch.show = false
        },
        commitBatchDelete() {
            deleteConfirm().then(() => {
                const params = {
                    ids: this.batch.selectRows.map((v) => v.id),
                    siteId: this.siteId
                }
                API.matterLogs.deleteMatterLog(params).then((res) => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.getMatterLog()
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            })
        },
        onBatchDeleteClick() {
            this.$refs.multipleTable.clearSelection()
            this.batch.show = true
            this.batch.mode = 'delete'
        },
        batchChangePriority(e) {
            this.batchChangeMatterLog('matterPriority', e)
        },
        batchChangeTypeDesc(e) {
            this.batchChangeMatterLog('matterStatus', e)
        },
        batchChangeClientUserName(e) {
            this.batchChangeMatterLog('clientUser', e)
        },
        batchChangeKpmgUserName(e) {
            this.batchChangeMatterLog('kpmgUser', e)
        },
        batchChangeMatterLog(column, e) {
            API.matterLogs
                .changeMatterLog({
                    matterLogIds: this.data.map((v) => v.id),
                    column: column,
                    value: `${e}`
                })
                .then((res) => {
                    this.$message.success(this.$t('msg_success'))
                    this.getMatterLog()
                })
        },
        downloadFile(file) {
            const params = {
                fileId: file.id ? file.id : file,
                siteId: this.siteId,
                source: 'matter'
            }
            downloadSingleFile(params)
        },
        handleFileClick(file, force = false) {
            if (!this.canDownload(file) || !this.hasPermission('download')) return false
            if (file.status == 'success' || force) {
                this.downloadFile(file)
            }
        },
        onUploadClick(row) {
            if (!this.hasPermission('upload')) {
                return
            }
            this.matterLogId = row.id
            this.initData = row
            this.$nextTick(() => (this.uploadVisible = true))
        },
        afterUploadAllFinish() {
            this.uploadVisible = false
            this.getMatterLog()
        },
        selectPriority: () => API.matterLogs.queryMatterLogPriority({}),
        selectClientOwner() {
            API.matterLogs.searchClientOwner({ siteId: this.siteId, searchContent: '' }).then((res) => {
                if (res.code == '1') {
                    this.clientOwnerList = res.data
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        selectKPOwner() {
            API.matterLogs.searchKpmgOwner({ siteId: this.siteId, searchContent: '' }).then((res) => {
                if (res.code == '1') {
                    this.kpmgOwnerList = res.data
                    this.kpmgOwnerList.map((item) => {
                        if (item.userName === 'Blank') {
                            item.userName = this.$t('common_empty')
                            item.profitCenter = this.$t('common_empty')
                        }
                    })
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        selectMatter() {
            API.matterLogs.queryMatterLogTypeDescs({}).then((res) => {
                this.matterLogTypeDescs = res.data
                this.matterLogTypeDescs.map((item) => {
                    if (item.label === 'Blank') {
                        item.label = this.$t('common_empty')
                    }
                })
            })
        },
        selectCategory: () => API.matterLogs.queryMatterLogCategory({}),
        commentCommit() {
            if (this.comment.loading) return
            this.comment.loading = true
            API.matterLogs
                .addComments({
                    id: this.comment.row.id,
                    comments: this.comment.content,
                    attachmentList: [],
                    siteId: this.getSite.siteId,
                    messageType:this.messageType
                })
                .then((res) => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.comment.content = ''
                        this.getMatterLog((e) => {
                            this.comment.data = this.data.find((v) => v.id == this.comment.row.id).commentList
                        })
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .catch((e) => {})
                .finally(() => {
                    this.comment.loading = false
                })
        },
        onCommentDialogClose() {
            this.comment.data = []
            this.comment.show = false
            this.comment.content = ''
            this.comment.loading = false
            this.comment.row = {}
        },
        deleteMessage(row) {
            this.comment.loading = true
            API.matterLogs
                .deleteComment({
                    ids: [row.id]
                })
                .then((res) => {
                    this.comment.loading = false
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.getMatterLog((e) => {
                            this.comment.data = this.data.find((v) => v.id == this.comment.row.id).commentList
                        })
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .catch((e) => {
                    console.error(e)
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.comment.loading = false
                })
        },
        onCommentClick(row) {
            this.comment.data = row.commentList
            this.comment.row = row
            this.comment.show = true
        },
        changeStatusFilter(v) {
            this.chooseStatus = v
        },
        getAuditType() {
            API.matterLogs.queryAuditType({}).then((res) => {})
        },
        getPriority() {
            API.matterLogs.queryMatterLogPriority({
            }).then((res) => {
                if (res.code == '1') {
                    this.priority = res.data.filter(item=>item.value !== 'Blank')
                    this.allPriority = res.data
                    this.allPriority.map((item) => {
                        if (item.label === 'Blank') {
                            item.label = this.$t('common_empty')
                        }
                    })
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        getMatterLogStatus() {
            API.matterLogs.queryMatterLogStatus({}).then((res) => {
                if (res.code == '1') {
                    this.statusDict = res.data
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        async getMatterLog(scb = false) {
            this.tableLoading = true
            await this.queryMatterInfo()
            let ids = []
            if (this.search.data.title && this.search.data.title.length > 0) {
                const idsWillIn = this.matterInfo.filter((v) => this.search.data.title.includes(v.title)).map((v) => v.id)
                ids = ids.length == 0 ? idsWillIn : ids.filter((v) => idsWillIn.includes(v))
            }
            if (this.search.data.matterDesc && this.search.data.matterDesc.length > 0) {
                const idsWillIn = this.matterInfo.filter((v) => this.search.data.matterDesc.includes(v.matterDesc)).map((v) => v.id)
                ids = ids.length == 0 ? idsWillIn : ids.filter((v) => idsWillIn.includes(v))
            }

            const params = {
                entityIds: this.getEntityIds,
                siteId: this.siteId,
                auditType: this.active,
                statusList: this.chooseStatus,
                dateRange: this.dateRange,
                matterLogIdList: ids,
                matterType: this.search.data.matterType,
                category: this.search.data.category,
                matterPriority: this.search.data.matterPriority,
                kpmgOwner: this.search.data.kpmgOwner,
                clientOwner: this.search.data.clientOwner,
                title: this.search.data.title,
                status: this.search.data.status,
                matterDesc: this.search.data.matterDesc,
                createDate: this.search.data.createDate,
                createBy: this.search.data.createBy,
                updateBy: this.search.data.updateBy,
                ...this.pagination,
                startCommentDate: this.search.data.commentDate && this.search.data.commentDate[0] ? dateFormat(new Date(this.search.data.commentDate[0]), 'yyyy-MM-dd') : null,
                endCommentDate: this.search.data.commentDate && this.search.data.commentDate[1] ? dateFormat(new Date(this.search.data.commentDate[1]), 'yyyy-MM-dd') : null,

            }

            if (this.search.data.searchContent) {
                params.searchContent = this.search.data.searchContent
            }
            params.matterDesc = params.matterDesc.map((item) => {
                if (item === this.$t('common_empty')) {
                    item = 'Blank'
                }
                return item
            })

            API.matterLogs.queryMatterLog(params).then((res) => {
                if (res.code == '1') {
                    this.tableLoading = false
                    this.data = res.data.records ? res.data.records.map((v) => {
                        if (v.attachmentList == null) {
                            v.attachmentList = []
                        }
                        return v
                    }): []
                    this.pagination.total = res.data.total
                    scb && scb(res)
                } else {
                    this.$message.error(this.$t(res.code))
                    this.tableLoading = false
                }
            })
        },
        async exportMatterLog() {
            const params = {
                    entityIds: this.getEntityIds,
                    siteId: this.siteId,
                    auditType: this.active,
                    statusList: this.chooseStatus,
                    dateRange: this.dateRange
                }
            await downloadFileByUrl(API.matterLogs.exportMatterLog,params)
        },
        toggleVisible({ row }) {
            this.data = _.map(this.data, (v) => (v.id === row.id ? Object.assign(v, { visible: !v.visible }) : v))
        },
        onDelete(row) {
            deleteConfirm().then(() => {
                const params = {
                    ids: [row.id],
                    siteId: this.siteId
                }
                API.matterLogs.deleteMatterLog(params).then((res) => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.getMatterLog()
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            })
        },
        onAddOrEditShow() {
            this.addOrEditVisible = !this.addOrEditVisible
        },
        onAddOrEdit() {
            this.addOrEditVisible = !this.addOrEditVisible
        },
        onAddShow() {
            this.current = {
                user: this.getUser,
                siteId: this.siteId,
                statusDict: this.statusDict,
                isNew: true,
                auditType: this.active
            }
            this.onAddOrEditShow()
        },
        onEditShow(row) {
            let organization = []
            let relatedIssue = []
            if (row.entityList) {
                row.entityList.forEach((i, n) => {
                    organization.push(i.id)
                })
            }
            if (row.relationLogList) {
                row.relationLogList.forEach((i, n) => {
                    relatedIssue.push(i.id)
                })
            }
            this.current = {
                user: this.getUser,
                id: row.id,
                siteId: this.siteId,
                statusDict: this.statusDict,
                isNew: false,
                auditType: this.active,
                commentList: row.commentList,
                formData: {
                    title: row.title,
                    matterType: row.typeDesc,
                    category: row.category,
                    organization: organization,
                    kpmgOwner: row.kpmgOwner,
                    clientOwner: row.clientOwner,
                    status: row.matterStatus,
                    priority: row.matterPriority,
                    relatedIssue: relatedIssue,
                    description: row.matterDesc,
                    attachmentList: row.attachmentList ? row.attachmentList : []
                }
            }
            this.onAddOrEditShow()
        },
        handleClick(val) {
            this.active = val
            this.getMatterLog()
        },
        onSizeChange(size) {
            this.pagination.pageSize = size
            this.pagination.pageNum = 1
            this.getMatterLog()
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getMatterLog()
        },
        selectFromLocal() {
            return Promise.resolve({
                code: '1',
                data: this.statusDict
            })
        },
        //是否显示
        showIcon(row, type) {
            return row.typeDesc == type
        },
        //显示什么图标
        showStatus(row) {
            return _.filter(this.statusDict, (v) => v.value == row.matterStatus)[0]
                ? _.filter(this.statusDict, (v) => v.value == row.matterStatus)[0].icon
                : ''
        },
        getMatterType() {
            API.matterLogs
                .queryMatterLogTypeDescs({})
                .then((res) => {
                    if (res.code === '1') {
                        const obj = {}
                        res.data.forEach((item) => {
                            obj[item.value] = item.label
                        })
                        this.mapMatterData = obj
                    }
                })
                .catch((e) => {
                    console.error(e)
                })

            API.matterLogs.queryMatterLogCategory({}).then((res) => {
                this.matterlogCategorys = res.data
            })
        }
    },
    async mounted() {
        setTimeout(() => {
            if(document.querySelector('.el-collapse-item__arrow'))document.querySelector('.el-collapse-item__arrow').style.display = 'none'
        }, 500)
        await this.getUserEntity('16')
        this.$store.commit('common/setEntityIds', this.allEntityIds)
        if(this.$route.query.active){
            this.active = this.$route.query.active
        }else{
            this.active = this.getSite.hasInterim ? '1' : '2'
        }
        
        //主页跳转
        if(this.$route.query.homeFilterStatus){
            this.chooseStatus = ((this.$route.query.homeFilterStatus).split(',')).map(item => Number(item))
        }
        await this.getMatterLog()
        // await this.queryMatterInfo()
        await this.queryLimits()
        // 获取下拉
        this.selectMatter()
        this.getAuditType()
        // this.getMatterLogStatus()
        this.getPriority()
        this.getMatterType()
        //TODO: 下列两个接口需要优化
        this.selectKPOwner()
        this.selectClientOwner()
    },
    components: {
        SelectMulti,
        PopHover,
        addOrEdit,
        Entity,
        Upload,
        MultiSelectPopver,
        DatePickerPopover,
        NewComments
    }
}
</script>

<style scoped>
.wl-matter-log-container {
    background: #ffffff;
    height: 100%;
}
.wl-container {
    color: #444;
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}


.wl-content-container {
    height: 100%;
    background: #fff;
    padding: 10px 22px;
    border-radius: 8px;
}
.search-line1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    height: 38px;
}
.clean-filter {
    font-size: 12PX;
    line-height: 30px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: black;
}
.clean-filter img {
    margin-right: 5px;
}
.tab-cls {
    display: flex;
    list-style: none;
    justify-content: flex-start;
    align-items: flex-start;
    height: 38px;
}
.tab-cls li {
    margin-right: 10px;
    background-color: #ccced2;
    height: 28PX;
    line-height: 28PX;
    border-radius: 14PX;
    color: #fff;
    font-size: 14PX;
    padding: 0 30px;
    cursor: pointer;
}
.tab-cls li.active {
    background-color: #3879eb;
}
.wl-container .fa {
    font-size: 18px;
    cursor: pointer;
}

.fa-square-o,
.wl-right > span:nth-child(1) {
    color: #e60405;
}

.fa-check,
.wl-right > span:nth-child(3) {
    color: #6fbf0a;
}

.fa-circle-o,
.wl-right > span:nth-child(2) {
    color: #49a2cf;
}

.wl-hover-content {
    width: 120px;
    height: 80px;
}

.wl-search-bar {
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.wl-left,
.search-line2 {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    height: 40px;
}

.search-line2 div {
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.search-line2 > .search-line2-left {
    justify-content: flex-start;
}
.search-line2 > .search-line2-right {
    justify-content: flex-end;
}
.search-line2 > div > span {
    padding: 0 12px;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-self: center;
    align-items: center;
    color: #333333;
}

.status-icon {
    width: 16px;
    margin-right: 5px;
}

.wl-green {
    margin-left: 16px;
}
.wl-header-desc-yes {
    color: #6fbf0a;
    font-weight: bolder;
    font-size: 16px;
}
::v-deep .el-collapse-item__content {
    padding-bottom: 0;
}
::v-deep .el-collapse-item__header {
    height: 35px;
    line-height: 35px;
}
.search-line1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}
.search-line1 > * {
    margin-bottom: 10px;
}
.search-item {
    width: 250px;
    margin-right: 10px;
}
.table-container-wrapper {
    height: calc(100% - 78px - 84px);
    transition: height 0.4s;
}
.table-container-wrapper.show-search-operator {
    height: calc(100% - 138px - 154px);
}
.table-container-wrapper.show-search-row {
    height: calc(100% - 138px - 104px);
}
.table-container-wrapper.show-table-bottom-operate {
    height: calc(100% - 78px - 134px);
}
.wl-icon-messageBoard,
.wl-icon-messageBoardNull {
    font-size: 18px;
    cursor: pointer;
}
.wl-icon-messageBoard {
    color: #3879eb;
}
.wl-icon-messageBoardNull {
    color: #c0c4cc;
}
.wl-icon-upload,
.wl-icon-not-upload {
    font-size: 18px;
    cursor: pointer;
}
.wl-icon-upload {
    color: #3879eb;
}
.wl-icon-not-upload {
    color: #c0c4cc;
}
.messageWarp {
    padding: 0 10px;
    max-width: 80%;
}
.messageBy {
    line-height: 20px;
    position: relative;
}
.messageContent {
    padding: 8px 5px;
    line-height: 25px;
    border-radius: 5px;
    text-align: left;
    position: relative;
    word-break: break-word;
}
.deleteButton {
    position: absolute;
    top: calc(50% - 7px);
    cursor: pointer;
    color: #dd6161;
}

.leftButton {
    left: -20px;
}

.rightButton {
    right: -20px;
}
.addMessage {
    border: #e9e9eb 1px solid;
    border-radius: 0 0 5px 5px;
    position: relative;
    padding-bottom: 36px;
}

.addMessage ::v-deep .el-textarea__inner {
    border: none;
}

.addMessage ::v-deep .el-textarea__inner:hover {
    border: none;
}
.wl-icon-send {
    font-size: 20px;
    line-height: 26px;
    padding: 0 3px;
    background-color: #409eff;
    color: #ffffff;
    border-radius: 13px;
    border: #409eff 1px solid;
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    right: 10px;
}
.wl-icon-send-disabled {
    background-color: #f3eee6;
    border: #f3eee6 1px solid;
    cursor: not-allowed;
}
.messageViewer {
    padding: 10px;
    border: #e9e9eb 1px solid;
    border-radius: 5px 5px 0 0;
    border-bottom: none;
    background: #f9f9f9;
    height: 50vh;
    overflow-y: scroll;
    text-align: center;
}

.leftMessage {
    background: #a8c8e7;
    border: #e9e9eb 1px solid;
    text-align: left;
}

.rightMessage {
    background: #ffffff;
    border: #e9e9eb 1px solid;
    text-align: right;
}
.floatLeft {
    float: left;
    text-align: left;
}
.floatRight {
    float: right;
    text-align: right;
}
.table-header-edit-cls {
    color: #3879eb;
}
.batch-operation {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: 50px;
}
.filelist {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
}
.file-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
.file-name {
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.file-name-canDownload {
    cursor: pointer;
}
.file-name:hover {
    background-color: #f2f2f2;
}
.file-icon {
    width: 10%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.del-uploaded-cls {
    display: none;
}

.file-icon:hover .del-uploaded-cls {
    display: inline-block;
    cursor: pointer;
}
.file-icon:hover .check-uploaded-cls {
    display: none;
}
.del-upload-cls-check {
    cursor: default !important;
}
.upload-drag {
    width: 100%;
}
.table-filelength {
    cursor: pointer;
    text-decoration: underline;
    color: blue;
}
.action-item {
    margin: 0 5px;
}
.action-item:hover {
    cursor: pointer;
    text-decoration: underline;
}
.option-text-overflow-dot {
    width: 140px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
::v-deep .el-tag {
    display: flex;
    flex-direction: row;
    align-items: center;
}
::v-deep .el-select__tags-text {
    display: inline-block;
    max-width: 68px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.file-table-name-canDownload:hover {
    text-decoration: underline;
    cursor: pointer;
    color: rgb(120, 120, 195);
}
::v-deep .el-table__row .el-icon-download {
    color: #3879eb;
}
.delete {
    color: #fd349c;
    cursor: pointer;
}
.header-with-popup {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

::v-deep .kp-update-row {
    background: #0091da;
    color: #ffffff;
}
::v-deep .kp-update-row .el-icon-download {
    color: #fff;
}
::v-deep .kp-update-row:hover {
    color: #93637c;
}
::v-deep .kp-update-row:hover .el-icon-download {
    color: #0091da;
}
</style>
